import * as _ from 'lodash-es';
import { AdminPermissionsGroup } from '../model/adminPermissionsGroup';
import { AdminPermissionsGroupList } from '../model/adminPermissionsGroupList';
import { AdminPermissionsBuilder } from './adminPermissions-builder';
export class AdminPermissionsGroupBuilder {
    static buildAdminPermissionsGroup(data) {
        const adminPermissionsGroup = new AdminPermissionsGroup();
        adminPermissionsGroup.id = data.id;
        adminPermissionsGroup.name = data.name;
        adminPermissionsGroup.permissions = _.map(data.permissions, (adminPermissionsGroup) => {
            return AdminPermissionsBuilder.buildAdminPermissions(adminPermissionsGroup);
        });
        return adminPermissionsGroup;
    }
    static buildAdminPermissionsGroupList(data) {
        const adminPermissionsGroupList = new AdminPermissionsGroupList();
        adminPermissionsGroupList.page = data.page;
        adminPermissionsGroupList.pagination = data.pagination;
        adminPermissionsGroupList.total = data.total;
        adminPermissionsGroupList.totalPages = data.totalPages;
        adminPermissionsGroupList.permissionsGroups = _.map(data.permissionsGroups, (adminPermissionsGroup) => {
            return AdminPermissionsGroupBuilder.buildAdminPermissionsGroup(adminPermissionsGroup);
        });
        return adminPermissionsGroupList;
    }
}
//# sourceMappingURL=adminPermissionsGroup-builder.js.map